"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonToI18nBundle = void 0;
var json_1 = require("./json");
Object.defineProperty(exports, "jsonToI18nBundle", { enumerable: true, get: function () { return json_1.jsonToI18nBundle; } });
//# sourceMappingURL=index.js.map